/**
 * The outcome carried back in the URL when Stripe's hosted checkout redirects
 * to /subscription — ?checkout=success&session_id=… or ?checkout=cancelled.
 */
export type CheckoutReturn =
  | { status: "success"; sessionId: string }
  | { status: "cancelled" };

/** Query params the checkout return flow consumes (and then strips from the URL). */
export const CHECKOUT_RETURN_PARAMS = ["checkout", "session_id"];

export const parseCheckoutReturn = (
  searchParams: URLSearchParams
): CheckoutReturn | null => {
  const checkout = searchParams.get("checkout");
  if (checkout === "cancelled") {
    return { status: "cancelled" };
  }
  if (checkout === "success") {
    const sessionId = searchParams.get("session_id");
    if (sessionId) {
      return { status: "success", sessionId };
    }
  }
  return null;
};
